import { render, staticRenderFns } from "./salesReturnList.vue?vue&type=template&id=76649890&scoped=true"
import script from "./salesReturnList.vue?vue&type=script&lang=js"
export * from "./salesReturnList.vue?vue&type=script&lang=js"
import style0 from "./salesReturnList.vue?vue&type=style&index=0&id=76649890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76649890",
  null
  
)

export default component.exports